import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdSenseScript"] */ "/vercel/path0/components/ads/adsense-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AutoAdsInit"] */ "/vercel/path0/components/ads/auto-ads-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CadastroConcluidoTracker"] */ "/vercel/path0/components/analytics/cadastro-concluido-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthModalProvider"] */ "/vercel/path0/components/auth/auth-modal-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthModal"] */ "/vercel/path0/components/auth/auth-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PendingCalcSaver"] */ "/vercel/path0/components/calc/pending-calc-saver.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/vercel/path0/components/common/cookie-consent-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkipToContent"] */ "/vercel/path0/components/common/skip-to-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteChrome"] */ "/vercel/path0/components/layout/site-chrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAInstallPrompt"] */ "/vercel/path0/components/pwa/install-prompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/vercel/path0/components/pwa/service-worker-register.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductTelemetry"] */ "/vercel/path0/components/telemetry/product-telemetry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/lib/auth/context.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"axes\":[\"opsz\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Space_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-space-grotesk\",\"weight\":[\"500\",\"600\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"spaceGrotesk\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-jetbrains-mono\",\"display\":\"swap\"}],\"variableName\":\"jetbrainsMono\"}");
